"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_PROPS = exports.UNMOUNT = exports.MOUNT = exports.CREATE = void 0;
var CREATE = 'data/views/CREATE';
exports.CREATE = CREATE;
var MOUNT = 'data/views/MOUNT';
exports.MOUNT = MOUNT;
var UNMOUNT = 'data/views/UNMOUNT';
exports.UNMOUNT = UNMOUNT;
var UPDATE_PROPS = 'data/props/UPDATE_PROPS';
exports.UPDATE_PROPS = UPDATE_PROPS;